import { render } from "./Step_5.vue?vue&type=template&id=24d1994b"
import script from "./Step_5.vue?vue&type=script&lang=js"
export * from "./Step_5.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__